<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.998 4.122" :style="{transform: reverse ? 'scale(-1)' : undefined}">
    <path clip-rule="evenodd" d="M5.903 1.826L4.196.097a.323.323 0 00-.462 0 .338.338 0 000 .47L4.88 1.728H.327A.33.33 0 000 2.061a.33.33 0 00.327.332H4.88l-1.146 1.16a.336.336 0 000 .471c.128.13.334.131.462 0l1.706-1.73a.337.337 0 000-.47z"/>
  </svg>
</template>

<script>
export default {
    props:{
        reverse: {
            type:  Boolean,
            default: false
        }
    }
}
</script>

<style>

</style>
